// src/components/admin/ProduitsEnAttente.jsx
import React, { useEffect, useState } from 'react';
import "../../styles/admin/produitEnAttente.css";
import { asset } from '../../services/api';

import {
  getProduitsEnAttenteAvecVendeur,
  validerProduit,
  rejeterProduit,
} from '../../services/admin/adminProduitService';

function ProduitsEnAttente() {
  const [produits, setProduits] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await getProduitsEnAttenteAvecVendeur();
        setProduits(data);
      } catch {
        alert('Erreur chargement produits');
      }
    };
    fetch();
  }, []);

  const handleValider = async (id) => {
    if (window.confirm('Valider ce produit ?')) {
      await validerProduit(id);
      setProduits(prev => prev.filter(p => p.id !== id));
    }
  };

  const handleRejeter = async (id) => {
    if (window.confirm('Rejeter ce produit ?')) {
      await rejeterProduit(id);
      setProduits(prev => prev.filter(p => p.id !== id));
      window.dispatchEvent(new Event('produitValide'));
    }
  };

  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2> Produits en attente de validation</h2>
      </div>

      {produits.length === 0 ? (
        <p>Aucun produit en attente</p>
      ) : (
        <div className="table-responsive">
          <table className="mes-produits-table">
            <thead>
              <tr>
                <th>Catégorie</th>
                <th>Titre</th>
                <th>Description</th>
                <th>Prix</th>
                <th>Stock</th>
                <th>Lieu</th>
                <th>Image</th>
                <th>Nom du vendeur</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {produits.map((prod) => (
                <tr key={prod.id}>
                  <td>{prod.categorie}</td>
                  <td>{prod.title}</td>
                  <td className="col-description">{prod.description}</td>
                  <td>{prod.price} Ar</td>
                  <td>{prod.stock} kg</td>
                  <td>{prod.lieu}</td>
                  <td>
                    {prod.img && (
                      <img
                        src={asset(prod.img)}                        
                        alt="Produit"
                        width="60"
                        height="60"
                        style={{ objectFit: 'cover', borderRadius: '6px' }}
                      />
                    )}
                  </td>
                  <td>{prod.vendeur_nom} {prod.vendeur_prenom}</td>
                  <td>{prod.vendeur_email}</td>
                  <td>📞 {prod.vendeur_telephone}</td>
                  <td className="action-buttons">
                    <button onClick={() => handleValider(prod.id)} className="btn-validate">✅</button>
                    <button onClick={() => handleRejeter(prod.id)} className="btn-reject">❌</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ProduitsEnAttente;
